// src/components/ProtectedRoute.jsx
import { Navigate, Outlet, useLocation } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';

const ProtectedRoute = ({ redirectPath = '/login' }) => {
  const { isAuthenticated, loading } = useAuth();
  const location = useLocation();

  // Show loading indicator or skeleton while checking authentication
  if (loading) {
    return <div className="text-center p-5">Loading...</div>;
  }

  // If not authenticated, redirect to login with the return url
  if (!isAuthenticated()) {
    return <Navigate to={`${redirectPath}?returnUrl=${encodeURIComponent(location.pathname)}`} replace />;
  }

  // If authenticated, render the child routes
  return <Outlet />;
};

export default ProtectedRoute;